export default "__VITE_ASSET__CZcGArfZ__"